import { createContext } from "react";
import { Country } from "./interfaces/Country";
import { ESPlayerData, } from "./interfaces/DetailedPlayer";
import { Gamemode } from "./interfaces/Gamemode";

export const CountryContext = createContext<Country>({} as Country);
export const GamemodeContext = createContext<Gamemode>(Gamemode.Osu);
export const PlayerContext = createContext<ESPlayerData>({} as ESPlayerData);